<template>
  <transition name="dates">
    <div v-if="showBox" class="DetailDate">
      <div class="date-header">
        <div class="date-close">
          <i class="iconfont close" @click="closeDateBox"></i>
        </div>
        <div class="date-agent">
          <img
            v-if="info.avatar && info.avatar.url"
            v-lazy="info.avatar.url"
            class="date-agent-avatar"
          />
          <div class="date-agent-intro">
            <div>Hi, this is {{ info.nickname }} from JODI Group, Inc. Thank you for choosing me to provide you with Real Estate Servies. Please leave me a message and I will contact you as soon as possible.</div>
            <div v-if="speakLang">I can speak {{ speakLang }}.</div>
          </div>
        </div>
      </div>
      <div class="date-form">
        <div class="form-base">
          <input
            v-model="input.name"
            class="input-item"
            type="text"
            title="input-name"
            placeholder="What should I call you"
          />
          <input
            v-model="input.phone"
            class="input-item"
            type="text"
            title="input-phone"
            placeholder="Your phone"
          />
        </div>
        <div class="form-email">
          <input
            v-model="input.email"
            class="input-item"
            type="email"
            title="input-phone"
            placeholder="Your email"
          />
        </div>
        <div class="form-content">
          <textarea v-model="input.content"></textarea>
        </div>
        <div class="form-notice" @click="preferMessage = !preferMessage">
          <i
            class="iconfont"
            :class="[preferMessage ? 'check-box-outline' : 'check-box-outline-bl']"
          ></i>
          <span>I prefer text messages</span>
        </div>
        <div class="form-footer">
          <div class="form-btn" @click="submitForm">Make appointment</div>
          <span
            v-if="showErrorTips"
            class="form-footer-tips"
          >Please leave more information so I can contact you.</span>
        </div>
      </div>
      <transition name="success">
        <div v-if="showSuccess" class="date-success">
          <i class="iconfont thumbs-up"></i>
          <span>Your appointment information has been received, I will deal with it immediately</span>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DetailDate',
  props: {
    showBox: {
      type: Boolean,
      default () {
        return false
      },
    },
    dateInfo: {
      type: [Array, Object],
      default () {
        return []
      },
    },
    house: {
      type: Object,
      default () {
        return {}
      },
    },
    isSell: {
      type: Boolean,
      default () {
        return false
      },
    },
  },
  data () {
    return {
      input: {
        name: '',
        phone: '',
        email: '',
        content: 'I am interested in ' + this.house.title,
      },
      preferMessage: false,
      showErrorTips: false,
      validate: {
        name: true,
        email: true,
        content: true,
      },
      showSuccess: false,
    }
  },
  computed: {
    info () {
      return Array.isArray(this.dateInfo) ? this.dateInfo[0] : this.dateInfo
    },

    speakLang () {
      if (this.dateInfo.language && this.dateInfo.language.length) {
        if (this.dateInfo.language.length === 1) {
          return this.dateInfo.language[0]
        } else if (this.dateInfo.language.length === 2) {
          return this.dateInfo.language[0] + ' and ' + this.dateInfo.language[1]
        } else {
          let langArr = this.dateInfo.language.slice(0, this.dateInfo.language.length - 2)
          return langArr.join(',') + ' and ' + this.dateInfo.language[this.dateInfo.language.length - 1]
        }
      }
      return false
    },
  },
  watch: {
    house () {
      this.input.content = 'I am interested in ' + this.house.title
    },
  },
  methods: {
    closeDateBox () {
      this.$emit('closeDateBox')
    },
    submitForm () {
      this.showErrorTips = false
      // if (this.validateForm()) {
      this.$axios({
        url: '/api/v1/client/estate/createAppointment',
        method: 'post',
        data: {
          name: this.input.name,
          email: this.input.email,
          message: this.input.content,
          relatedId: this.house.id,
          type: this.isSell ? 'sell' : 'rental',
          agentId: this.info.id,
          mobilePhone: this.input.phone,
          preferMessage: this.preferMessage,
        },
      }).then(res => {
        if (res.ok) {
          this.showSuccess = true
          setTimeout(() => {
            this.showSuccess = false
            this.closeDateBox()
            this.resetForm()
          }, 1000)
        }
      })
      // } else {
      //   this.showErrorTips = true
      // }
    },
    validateForm () {
      // 校验姓名
      if (this.input.name.length < 2) {
        this.validate.name = false
        return false
      }
      // 未填写手机号时
      let reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/ //正则表达式
      if (!this.input.phone.length) {
        // 校验邮箱
        if (!reg.test(this.input.email)) {
          //正则验证不通过，格式不对
          this.validate.email = false
          return false
        }
      } else {
        if (this.input.email.length) {
          if (!reg.test(this.input.email)) {
            //正则验证不通过，格式不对
            this.validate.content = false
            return false
          }
        }
      }
      // 检验content
      if (!this.input.content.length) {
        this.validate.email = false
        return false
      }
      return true
    },
    resetForm () {
      this.input = {
        name: '',
        phone: '',
        email: '',
        content: 'I am interested in ' + this.house.title,
      }
      this.preferMessage = false
      this.showErrorTips = false
      this.validate = {
        name: true,
        email: true,
        content: true,
      }
      this.showSuccess = false
    },
  },
}
</script>

<style scoped lang="less">
.DetailDate {
  position: absolute;
  right: 50px;
  bottom: -500px;
  width: 720px;
  height: 500px;
  background: #ffffff;
  box-shadow: 3px 7px 26px 0 rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .date-header {
    position: relative;

    .date-close {
      height: 35px;
      cursor: pointer;
      .iconfont {
        position: absolute;
        right: 20px;
        top: 20px;
        color: rgba(0, 0, 0, 0.5);
      }
    }

    .date-agent {
      display: flex;
      margin: 10px auto 0;
      padding-bottom: 20px;
      width: 91.67%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .date-agent-avatar {
        display: inline-block;
        width: 50px;
        height: 50px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        object-fit: cover;
      }

      .date-agent-intro {
        margin-left: 18px;
        width: 575px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
      }
    }
  }

  .date-form {
    margin: 18px 30px;

    input {
      margin-right: 26px;
      width: 260px;
      height: 42px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 6px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      font-size: 14px;
      color: rgba(0, 0, 0, 1);
      line-height: 42px;
      text-indent: 17px;
      outline: none;
    }

    input:focus {
      border: 1px solid rgba(153, 210, 13, 1);
    }

    textarea {
      width: 518px;
      height: 96px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 6px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      font-size: 14px;
      color: rgba(0, 0, 0, 1);
      line-height: 20px;
      padding: 10px 17px;
      resize: none;
      outline: none;
    }

    textarea:focus {
      border: 1px solid rgba(153, 210, 13, 1);
    }

    .form-base,
    .form-email {
      margin-bottom: 18px;
    }

    .form-content {
      margin-bottom: 13px;
    }

    .form-notice {
      margin-bottom: 15px;
      width: 180px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
      cursor: pointer;

      .iconfont {
        margin-right: 9px;
        font-size: 12px;
        vertical-align: middle;
      }

      .check-box-outline {
        color: rgba(153, 210, 13, 1);
      }
    }

    .form-footer {
      .form-btn {
        display: inline-block;
        margin-right: 26px;
        width: 260px;
        height: 42px;
        background: rgba(153, 210, 13, 1);
        border-radius: 6px;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
        text-align: center;
        cursor: pointer;
      }

      .form-footer-tips {
        font-size: 12px;
        color: rgba(0, 0, 0, 1);
        line-height: 17px;
      }
    }
  }

  .date-success {
    position: absolute;
    top: 163px;
    left: 236px;
    width: 249px;
    height: 173px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 7px 26px 0 rgba(0, 0, 0, 0.3);
    border-radius: 6px;

    .iconfont {
      display: block;
      margin-top: 49px;
      margin-bottom: 20px;
      font-size: 28px;
      color: rgba(0, 0, 0, 1);
      text-align: center;
    }

    span {
      display: block;
      margin: 0 auto;
      width: 195px;
      font-size: 12px;
      color: rgba(0, 0, 0, 1);
      line-height: 17px;
      text-align: center;
    }
  }
}

.dates-enter-active {
  transition: all 0.2s ease-out;
}

.dates-leave-active {
  transition: all 0.2s ease-in;
}

.dates-enter {
  transform: translateY(500px);
  opacity: 1;
}

.dates-leave-to {
  transform: translateY(500px);
  opacity: 0;
}

.success-enter-active {
  transition: all 0.2s linear;
}

.success-leave-active {
  transition: all 0.2s linear;
}

.success-enter {
  opacity: 0;
}

.success-leave-to {
  opacity: 0;
}

@media (max-width: 767px) {
  .DetailDate {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    max-height: 90vh;
    overflow-y: auto;
    border-radius: 10px 10px 0 0;

    .date-header {
      .date-agent {
        width: auto;
        margin: 8px 16px 0;

        .date-agent-intro {
          width: auto;
          min-width: 0;
          font-size: 13px;
        }
      }
    }

    .date-form {
      margin: 16px;

      input,
      textarea {
        width: 100%;
        box-sizing: border-box;
        margin-right: 0;
      }

      input {
        margin-bottom: 12px;
      }

      .form-base,
      .form-email,
      .form-content {
        margin-bottom: 0;
      }

      .form-notice {
        width: 100%;
        margin-top: 12px;
      }

      .form-footer {
        .form-btn {
          width: 100%;
          margin-right: 0;
        }

        .form-footer-tips {
          display: block;
          margin-top: 10px;
        }
      }
    }

    .date-success {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
